import React from "react";

const YouTubeShort = ({ videoId }) => {
    const videoUrl = `https://www.youtube.com/embed/${videoId}`;
    return (
        <>
            <iframe
                className="radius-6 overflow-hidden"
                src={videoUrl}
                allowFullScreen
                allow="autoplay"
                width={414}
                height={636}
            ></iframe>
        </>
    );
};

export default YouTubeShort;